import './home.css';
import React, { useEffect, useState } from 'react';

function Home() {
  const [cubbyStates, setCubbyStates] = useState(Array(25).fill(false));

  const handleCubbyClick = (index) => {
    setCubbyStates(prev => {
      const newStates = [...prev];
      newStates[index] = !newStates[index];
      return newStates;
    });
  };

  useEffect(() => {
    // Check if user prefers dark mode
    const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    
    if (prefersDarkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }

    // Listen for changes in color scheme preference
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      if (e.matches) {
        document.body.classList.add('dark-mode');
      } else {
        document.body.classList.remove('dark-mode');
      }
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return (
    <div className="Home">
        <div className="boxMain">
            <div className="grid grid-top">
                {[...Array(8)].map((_, i) => (
                    <div key={`top-${i}`} className="grid-item">
                    </div>
                ))}
            </div>
            <div className="grid grid-left">
                {[...Array(4)].map((_, i) => (
                    <div key={`left-${i}`} className="grid-item">
                    </div>
                ))}
            </div>
            {[...Array(25)].map((_, i) => (
                <React.Fragment key={i}>
                    <div 
                        className={`cubby cubby${i} ${cubbyStates[i] ? 'open' : ''}`} 
                        onClick={() => handleCubbyClick(i)}
                    >
                        <div className='numbering'></div>
                    </div>
                    <div className={`cubby-container cubby${i}-container`}></div>
                </React.Fragment>
            ))}
            <div className="grid grid-right">
                {[...Array(4)].map((_, i) => (
                    <div key={`right-${i}`} className="grid-item">
                    </div>
                ))}
            </div>
            <div className="grid grid-bottom">
                {[...Array(8)].map((_, i) => (
                    <div key={`bottom-${i}`} className="grid-item">
                    </div>
                ))}
            </div>
        </div>
    </div>
  );
}

export default Home;
